import { render, staticRenderFns } from "./DrawingCanvas.vue?vue&type=template&id=7ff24abe&scoped=true&lang=pug&"
import script from "./DrawingCanvas.vue?vue&type=script&lang=ts&"
export * from "./DrawingCanvas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff24abe",
  null
  
)

export default component.exports